
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertsShelf as ObiAlertsShelfElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alerts-shelf.js';
 
 
 

 
 export const ObiAlertsShelf = createComponent({
   react: React,
   tagName: 'obi-alerts-shelf',
   elementClass: ObiAlertsShelfElement,
   events: {
     
   }
  });
 
 